const labels = {
  inviteFriends: 'Invite friends & get up to $55',
  logOut: 'Log out',
}

export default labels
